export const unreachable = (value) => {
    throw new Error(`Unreachable code: ${value}`);
};
const GeneratorResultConstructor = (function* () { })().constructor;
export function isGeneratorResult(value) {
    return value.constructor === GeneratorResultConstructor;
}
export function isPromise(value) {
    return value.constructor === Promise;
}
export function isThennable(value) {
    return value !== null && typeof value === 'object' && typeof value.then === 'function';
}
